/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-04-16 15:50:34
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-04-23 11:24:45
 * @FilePath: /seller-station-client/src/atom/mall/user.ts
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { atom } from 'jotai';

/** 用户汇率 */
export const systemUserRate = atom<number | undefined>(7);

export const isLogin = atom<boolean>(false);

export const isVip = atom<boolean>(false);

export const openVip = atom<boolean>(false);
